import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-section-summary',
  templateUrl: 'section-summary.component.html',
  styleUrl: './section-summary.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class SectionSummaryComponent {}
